<header>
  <div class="container-fluid" id="myContainer">
    <div
      class="
        row
        d-flex
        align-items-center
        justify-content-between justify-content-sm-center
      "
    >
      <div class="nrev col-md-8 col-lg-4 text-uppercase pb-5">
        <div class="new">
          <h6>new revolutionized</h6>
        </div>
        <h1 class="font-weight-bold anim">internet marketing solutions</h1>

        <div class="video-box">
          <video
            id="my-video"
            class="video-js w-100"
            controls
            preload="auto"
            poster="{{
              myLinksS3URL
            }}frontend/greetingsgofound3/images/greeting2.png"
            data-setup="{}"
          >
            <source
              src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>

      <div class="col-lg-4 text-center position-relative">
        <div class="logo">
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october(2)/img/ringone.png"
            class="ringone"
            alt="ringone"
          />
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october(2)/img/ringtwo.png"
            class="ringtwo"
            alt="ringtwo"
          />
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october(2)/img/ringthree.png"
            class="ringthree"
            alt="ringthree"
          />
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october(2)/img/lgbck.png"
            class="logoback position-absolute"
            alt="logoback"
          />
          <img
            src="{{ onPassiveBaseUrl }}onpassive-october(2)/img/logo.png"
            class="logopng"
            alt="logopng"
            width="200"
          />
        </div>
      </div>

      <div class="launch-sec col-xs-8 col-sm-8 col-md-8 col-lg-4">
        <div class="launchhead">
          <!-- <h2>LAUNCHING SOON!</h2> -->
          <h1 class="ml15">
            <span class="word">LAUNCHING</span>
            <span class="word">SOON!</span>
          </h1>
        </div>
        <div class="launchtext text-justify">
          <p>
            How would it feel if you didn't have to think about money and the
            ways you can earn it? Great right!! Presenting ONPASSIVE that erases
            all your finance worries. An automated earning platform that gives
            you freedom to work from your home and enjoy quality time with your
            family. Moreover, you can enjoy hands-free working. Join now before
            time runs out
          </p>
          <div class="bfn mt-4">
            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              class="btn text-uppercase"
              target="_blank"
              rel="noopener"
              >become a founder now</a
            >
          </div>
        </div>
      </div>

      <div class="pics text-center position-relative">
        <img
          src="{{ onPassiveBaseUrl }}onpassive-october(2)/img/blayer.png"
          class="top-layer img-fluid"
          alt="top-layer"
        />
      
      </div>
    </div>
  </div>
</header>
